{
  "title": "Outils de données",
  "subtitle": "Faites entrer vos données depuis Excel, sortez-les, et protégez-les avec des sauvegardes.",
  "nothing": "Votre rôle ne donne accès à aucun import ni export.",
  "import": {
    "title": "Importer des produits depuis Excel",
    "subtitle": "Excel (.xlsx) ou CSV, en français ou en anglais. Rien n'est créé avant votre confirmation.",
    "template": "Télécharger le modèle",
    "kind": "Quoi importer",
    "kinds": {
      "products": "Produits",
      "openingStock": "Stock d'ouverture",
      "categories": "Catégories",
      "units": "Unités",
      "brands": "Marques"
    }
  },
  "steps": {
    "choose": "Choisir le fichier",
    "chooseHint": "Excel ou CSV, 10 Mo maximum",
    "check": "Vérifier",
    "checkHint": "Chaque ligne est vérifiée",
    "checking": "Vérification…",
    "checkingLong": "Vérification de {{file}} : chaque ligne, chaque code, chaque nombre…",
    "checkFailed": "Le fichier n'a pas pu être lu",
    "problems_one": "Nous avons trouvé {{formatted}} problème",
    "problems_many": "Nous avons trouvé {{formatted}} problèmes",
    "problems_other": "Nous avons trouvé {{formatted}} problèmes",
    "noProblem": "Aucun problème trouvé",
    "import": "Importer",
    "importHint": "Les produits sont créés",
    "importing": "Import en cours…",
    "done": "Terminé"
  },
  "choose": {
    "drop": "Déposez votre fichier ici ou cliquez pour choisir",
    "limits": "Excel (.xlsx) ou CSV · 10 Mo et 50 000 lignes maximum",
    "another": "Cliquez pour choisir un autre fichier",
    "wrongType": "Utilisez un fichier Excel (.xlsx) ou CSV",
    "tooLarge": "Le fichier doit faire 10 Mo au maximum",
    "createMissing": "Créer les catégories et marques manquantes",
    "createMissingHint": "Sinon, les lignes avec une catégorie ou une marque inconnue sont signalées. Les unités doivent exister : elles fixent les décimales.",
    "updateExisting": "Mettre à jour les produits qui existent déjà (même référence)",
    "updateExistingHint": "Les cellules vides gardent la valeur actuelle. Sans cette option, les références existantes sont signalées comme des problèmes.",
    "check": "Vérifier le fichier"
  },
  "check": {
    "file": "Fichier",
    "rowsRead": "Lignes lues",
    "ready": "Prêtes à importer",
    "needFixing": "Lignes à corriger",
    "updates": "{{create}} nouveaux produits et {{update}} mises à jour de produits existants.",
    "columns_one": "{{count}} colonne reconnue",
    "columns_many": "{{count}} colonnes reconnues",
    "columns_other": "{{count}} colonnes reconnues",
    "ignoredCount_one": "· {{count}} colonne ignorée",
    "ignoredCount_many": "· {{count}} colonnes ignorées",
    "ignoredCount_other": "· {{count}} colonnes ignorées",
    "ignored": "Non importées (aucun champ correspondant) : {{headers}}.",
    "row": "Ligne",
    "product": "Produit",
    "column": "Colonne",
    "problem": "Problème et comment le corriger",
    "empty": "(vide)",
    "allGood": "Toutes les lignes peuvent être importées.",
    "showing": "{{shown}} problèmes affichés sur {{total}}",
    "showAll": "Tout afficher",
    "showLess": "Afficher moins",
    "downloadErrors": "Télécharger la liste des erreurs",
    "uploadFixed": "Envoyer un fichier corrigé",
    "otherFile": "Choisir un autre fichier",
    "importGood_one": "Importer la ligne correcte",
    "importGood_many": "Importer les {{formatted}} lignes correctes",
    "importGood_other": "Importer les {{formatted}} lignes correctes",
    "importAll_one": "Importer {{formatted}} produit",
    "importAll_many": "Importer {{formatted}} produits",
    "importAll_other": "Importer {{formatted}} produits",
    "name": "Nom"
  },
  "outcome": {
    "importing": "Import en cours : {{processed}} lignes sur {{total}}",
    "importingHint": "Vous pouvez quitter cette page : l'import continue, et vous retrouverez le résultat ici.",
    "failed": "L'import n'a pas abouti",
    "missingColumns": "Ces colonnes obligatoires manquent : {{columns}}. Utilisez le modèle, ou nommez vos colonnes nom, catégorie et unité.",
    "tryAgain": "Essayer un autre fichier",
    "done": "Import {{number}} terminé",
    "created_one": "{{formatted}} produit créé",
    "created_many": "{{formatted}} produits créés",
    "created_other": "{{formatted}} produits créés",
    "updated_one": "{{formatted}} produit mis à jour",
    "updated_many": "{{formatted}} produits mis à jour",
    "updated_other": "{{formatted}} produits mis à jour",
    "categories_one": "{{count}} catégorie créée",
    "categories_many": "{{count}} catégories créées",
    "categories_other": "{{count}} catégories créées",
    "brands_one": "{{count}} marque créée",
    "brands_many": "{{count}} marques créées",
    "brands_other": "{{count}} marques créées",
    "another": "Importer un autre fichier",
    "seeProducts": "Voir les produits"
  },
  "other": {
    "title": "Autres imports et exports",
    "exportTitle": "N'importe quelle liste vers Excel",
    "exportText": "Produits, emplacements, utilisateurs, unités, catégories, marques…",
    "export": "Exporter",
    "templatesTitle": "Modèle Excel",
    "templatesText": "Le fichier produits avec les bonnes colonnes, vos listes et l'aide",
    "download": "Télécharger",
    "openingTitle": "Stock d'ouverture",
    "openingText": "Quantités et coûts par emplacement au démarrage",
    "listsTitle": "Listes",
    "listsText": "Catégories, unités et marques depuis un fichier",
    "import": "Importer"
  },
  "export": {
    "title": "Exporter une liste vers Excel",
    "hint": "Dans votre langue, avec les coûts seulement si vous pouvez les voir.",
    "download": "Télécharger",
    "lists": {
      "products": "Produits",
      "locations": "Emplacements",
      "users": "Utilisateurs",
      "units": "Unités de mesure",
      "categories": "Catégories",
      "brands": "Marques",
      "adjustment-reasons": "Motifs d'ajustement",
      "operations": "Entrées et sorties",
      "stock-levels": "Niveaux de stock",
      "movements": "Mouvements de stock",
      "activity": "Journal d'activité",
      "transfers": "Transferts",
      "customers": "Clients"
    },
    "details": {
      "products": "Produits actifs avec stock, limites et prix",
      "locations": "Les sites et leurs sous-emplacements",
      "users": "Les personnes, leurs rôles et où elles travaillent",
      "units": "Avec leurs décimales et leur utilisation",
      "categories": "Tout l'arbre, un chemin par ligne",
      "brands": "Avec leur utilisation",
      "adjustment-reasons": "Avec leur sens",
      "operations": "Chaque opération avec son statut et sa valeur",
      "stock-levels": "Quantités par emplacement, total et valeur",
      "movements": "Le registre : chaque variation de quantité",
      "activity": "Chaque action enregistrée",
      "transfers": "Chaque transfert avec ses endroits, ses dates et son statut",
      "customers": "Coordonnées, adresse par défaut, étiquettes et consentement"
    }
  },
  "backups": {
    "title": "Sauvegardes",
    "now": "Sauvegarder maintenant",
    "started": "Sauvegarde lancée : elle s’écrit en arrière-plan",
    "automatic": "Sauvegarde automatique chaque jour à {{time}}.",
    "kept_one": "Gardée {{count}} jour.",
    "kept_many": "Gardées {{count}} jours.",
    "kept_other": "Gardées {{count}} jours.",
    "last": "Dernière : {{when}}, {{size}}.",
    "noneYet": "La première a lieu cette nuit.",
    "empty": "Aucune sauvegarde pour l’instant.",
    "auto": "automatique",
    "manualBy": "manuelle par {{name}}",
    "done": "Terminée",
    "failed": "Échouée",
    "running": "En cours",
    "download": "Télécharger",
    "restoreTitle": "Restaurer une sauvegarde",
    "restoreText": "Rétablit toutes les données et les fichiers d'une sauvegarde. Réservé à l'administrateur, confirmé par le nom de l'entreprise.",
    "safety": "copie de sécurité avant une restauration"
  },
  "opening": {
    "title": "Importer le stock d'ouverture",
    "subtitle": "Quantités et coûts par emplacement au démarrage. L'import prépare un brouillon : vous le vérifiez et le validez.",
    "hint": "Chaque ligne indique un produit (référence ou code-barres), un emplacement (code ou nom), la quantité et le coût unitaire. Les lignes sans quantité sont ignorées.",
    "create_one": "Créer le brouillon de stock d'ouverture ({{formatted}} ligne)",
    "create_many": "Créer le brouillon de stock d'ouverture ({{formatted}} lignes)",
    "create_other": "Créer le brouillon de stock d'ouverture ({{formatted}} lignes)",
    "done": "Brouillon {{number}} créé",
    "doneText_one": "{{formatted}} ligne est prête. Rien n'a encore bougé : vérifiez-la et validez.",
    "doneText_many": "{{formatted}} lignes sont prêtes. Rien n'a encore bougé : vérifiez-les et validez.",
    "doneText_other": "{{formatted}} lignes sont prêtes. Rien n'a encore bougé : vérifiez-les et validez.",
    "review": "Vérifier et valider"
  },
  "restore": {
    "action": "Restaurer",
    "title": "Restaurer cette sauvegarde",
    "warningTitle": "Les données reviennent au {{when}}",
    "replaces": "Tout ce qui a été saisi depuis est remplacé : produits, stock, commandes, paiements, utilisateurs, réglages et fichiers.",
    "safety": "Une copie de sécurité des données actuelles est faite d'abord : vous pouvez y revenir depuis la liste.",
    "closed": "L'application est fermée pour tous pendant l'opération.",
    "signedOut": "Chacun se reconnecte ensuite, avec les comptes et mots de passe de la sauvegarde.",
    "archive": "Faite avec la version {{version}} de la base « {{database}} ».",
    "type": "Tapez le nom de l'entreprise pour confirmer : {{name}}",
    "confirm": "Restaurer",
    "fromFile": "Restaurer depuis un fichier",
    "tooLarge": "Le fichier dépasse {{max}} Go.",
    "start": "Restaurer",
    "discard": "Retirer le fichier",
    "statuses": {
      "ready": "En attente de confirmation",
      "running": "En cours",
      "done": "Restaurée",
      "failed": "Échec"
    },
    "safetyCopy": "copie de sécurité : {{name}}",
    "stockOk": "rapprochement du stock OK",
    "stockDiff_one": "{{count}} écart de stock trouvé",
    "stockDiff_many": "{{count}} écarts de stock trouvés",
    "stockDiff_other": "{{count}} écarts de stock trouvés",
    "errors": {
      "manifest": "Ce fichier n'est pas une sauvegarde Light BM.",
      "format": "Cette sauvegarde a été faite par une version plus ancienne et ne peut pas être restaurée.",
      "unreadable": "Le fichier est abîmé ou coupé : il ne peut pas être lu jusqu’au bout.",
      "incomplete": "La sauvegarde est incomplète (coupée avant la fin).",
      "database": "Les données de la sauvegarde ne sont pas en ordre.",
      "files": "Les fichiers de la sauvegarde ne sont pas en ordre.",
      "missing": "Le fichier de la sauvegarde n'est plus dans le stockage.",
      "safety": "La copie de sécurité n'a pas pu être faite : rien n'a changé.",
      "unavailable": "Le service d'arrière-plan n'était pas disponible : rien n'a changé.",
      "unexpected": "Une erreur inattendue l'a arrêtée (voir les journaux du serveur)."
    },
    "partial": "Les données sont peut-être restaurées en partie : restaurez la copie de sécurité."
  },
  "lists": {
    "fromFile": "Importer depuis un fichier",
    "skipped_one": "{{formatted}} ligne trouvée entre-temps dans la liste, laissée telle quelle",
    "skipped_many": "{{formatted}} lignes trouvées entre-temps dans la liste, laissées telles quelles",
    "skipped_other": "{{formatted}} lignes trouvées entre-temps dans la liste, laissées telles quelles",
    "categories": {
      "title": "Importer des catégories",
      "subtitle": "Excel (.xlsx) ou CSV. Les catégories déjà dans la liste restent telles quelles.",
      "hint": "Chaque ligne donne une catégorie, avec le chemin de sa catégorie parente dans « parent » ou le chemin complet dans le nom (Peinture > Intérieur). Les parentes manquantes sont créées au passage.",
      "create_one": "Créer {{formatted}} catégorie",
      "create_many": "Créer {{formatted}} catégories",
      "create_other": "Créer {{formatted}} catégories",
      "created_one": "{{formatted}} catégorie créée",
      "created_many": "{{formatted}} catégories créées",
      "created_other": "{{formatted}} catégories créées",
      "see": "Voir les catégories"
    },
    "units": {
      "title": "Importer des unités",
      "subtitle": "Excel (.xlsx) ou CSV. Les unités déjà dans la liste (par nom ou symbole) restent telles quelles.",
      "hint": "Chaque ligne donne une unité, son symbole et le nombre de décimales de ses quantités.",
      "create_one": "Créer {{formatted}} unité",
      "create_many": "Créer {{formatted}} unités",
      "create_other": "Créer {{formatted}} unités",
      "created_one": "{{formatted}} unité créée",
      "created_many": "{{formatted}} unités créées",
      "created_other": "{{formatted}} unités créées",
      "see": "Voir les unités"
    },
    "brands": {
      "title": "Importer des marques",
      "subtitle": "Excel (.xlsx) ou CSV. Les marques déjà dans la liste restent telles quelles.",
      "hint": "Un nom de marque par ligne.",
      "create_one": "Créer {{formatted}} marque",
      "create_many": "Créer {{formatted}} marques",
      "create_other": "Créer {{formatted}} marques",
      "created_one": "{{formatted}} marque créée",
      "created_many": "{{formatted}} marques créées",
      "created_other": "{{formatted}} marques créées",
      "see": "Voir les marques"
    }
  }
}
